<script lang="ts">
import { defineComponent } from '@vue/composition-api';

interface IProps {
    title: string;
}

const NotificationSettingsBlock = defineComponent<IProps>({
    name: 'NotificationSettingsBlock',
    props: {
        title: String,
    },
});

export default NotificationSettingsBlock;
</script>

<template functional>
  <div class="notification-setting-block">
    <div class="subtitle-2 my-1">
      {{ props.title }}
    </div>
    <slot />
  </div>
</template>

<style lang="scss" scoped></style>
